import { SvgIcon, SxProps } from "@mui/material";
import SupportUserSvg from "jsx:../../../Images/Icons/Custom/c24-support.svg";

export function SupportUserIcon(props: SxProps) {
    return <SvgIcon component={SupportUserSvg} inheritViewBox sx={props} />;
}
